import React from 'react'
import { Link } from 'react-router-dom'
import ThemeBtn from '../ThemeBtn/ThemeBtn'

import './BlogPage.scss'

function BlogCard(props) {
    return (
        <div className='BlogCard_inr'>
            <img className="blog_img" src={props.CardImg} alt="img" />
            <div className="content">
                <p className="desc heading_SB">{props.CardTitle}  <span className="desc_inr heading_S">  •  {props.CardDate} </span></p>
                <Link className="card_heading heading_h3" to='/blog_details'>
                    {props.CardHeading}
                </Link>
                <p className="desc_1 heading_S">
                    {props.CardDesc}
                </p>
                <Link className="action" to='/blog_details'>
                    <ThemeBtn
                        ButtonClass="btn_outline btn_read"
                        ButtonText="Read More"
                    />
                </Link>
            </div>
        </div>
    )
}

export default BlogCard